import DataViewerModel from "../../DataViewerModel.js";
import ResponsiveModel from "../../responsive/ResponsiveModel.js"; // import ItemModelInitializer from '../../../attributes/ItemsModelInitializer'
// import TableModelInitializer from '../../../attributes/TableModelInitializer'
export default function convert(old, opts) {
  const {
    settingsRoot,
    usedSettingsPath,
    getSettingsAt
  } = opts;
  const settings = createSettings(opts); // opts is incorrect here
  const large = getSettingsAt(`${settingsRoot}/table`);
  const small = getSettingsAt(`${settingsRoot}/list`);
  usedSettingsPath.add(`${settingsRoot}/table`);
  usedSettingsPath.add(`${settingsRoot}/list`);
  if (large) {
    settings.dataViewers[1].settings = large;
  }
  if (small) {
    settings.dataViewers[0].settings = small;
  }
  return DataViewerModel.create('molten.TableList', settings);
}
function createSettings(props) {
  const small = DataViewerModel.create('molten.List', createListSettings(props));
  const large = DataViewerModel.create('molten.Table', createTableSettings(props));
  const mdl = ResponsiveModel.create({
    dataViewers: [small, large],
    breakpoints: ['minWidth']
  });
  return mdl;
}
function createListSettings(props) {
  // We dont know the type, so have to do this later
  return null;
  // const { objectType } = props
  // console.log( "Convert List Settings", objectType)
  // return ItemModelInitializer.create( objectType, props )
}
function createTableSettings(props) {
  // We dont know the type, so have to do this later
  return null;
  // return TableModelInitializer.create( props.objectType, true, props )
}
convert.TYPE = 'responsiveTable';